import {Flex, Text} from '@chakra-ui/react'
import React from 'react'
import {FormattedMessage, FormattedNumber} from 'react-intl'
import {useOrderSummary} from './order-summary-provider'
import {useD2BCustomer} from '../../hooks/use-d2b-customer'

const OrderSummarySubtotal = () => {
    const basket = useOrderSummary()
    const isD2BEnabled = useD2BCustomer().isCustomNetPriceEnabled
    return (
        <Flex justify="space-between" gap={6} minWidth="100%">
            <Flex gap={2} data-testid="subtotal_text">
                <Text>
                    <FormattedMessage defaultMessage="Subtotal" id="order_summary.label.subtotal" />
                </Text>
                {isD2BEnabled && (
                    <Text color="stokkeGray.accessibleText">
                        <FormattedMessage
                            id="global.taxes_not_included"
                            defaultMessage="tax not included"
                        />
                    </Text>
                )}
            </Flex>
            <Text data-testid="subtotal_value">
                <FormattedNumber
                    style="currency"
                    currency={basket?.currency}
                    value={
                        !isD2BEnabled ? basket?.productSubTotal : basket?.c_productSubTotalNetPrice
                    }
                />
            </Text>
        </Flex>
    )
}

export default OrderSummarySubtotal
